declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, ExpenseVoucherController, ExpenseVoucherRequest, ExpenseVouchersRequest, ExpenseVouchersController, SaveExpenseVoucherRequest, LabOrdersRequest, LabOrderRequestsController, GenericProcPostRequest, S_Methods, DeleteLabOrderRequest } from '../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../src/app/ncs/services/actor.service';
//import { NgbAddNewPatient } from '../../../modal/addnewpatient.modal';
//import { NgbCameraUploadModal } from '../profile/patientprofileview/personaldetailview/modal/cameraupload.modal';
//import { NgbViewItemDetailsModal } from './modal/viewitemdetails.modal';
import { NGXToastrService } from '../../../shared/services/toastr.service';
import { ExpenseVoucherpipe } from '../../pipes/actors/actorIdentity.pipes';
import { NgxSpinnerService } from 'ngx-spinner';
import { PrintService } from '../../../../../src/app/ncs/services/print.service';





@Component({
  selector: 'labdashboard',
  templateUrl: './labdashboard.component.html',
  styleUrls: [
    './labdashboard.component.scss']
  , animations: [routerTransition()]
})

export class LabDashboardComponent implements OnInit {


  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
    public Selectedtoday: string = '';
  public SelectedDuration: string = '';
  public DetailsSection: boolean = false;
  public ShowRegister: boolean = true;
  public Showrow: boolean = true;
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
    public isdisplaydate: boolean = false;
    public LoadData: string;
    public LoadDataOld: string = 'Yes';
    public searchText: any;
    public Selectedfd: any;
    public frdate: Date;
    public Selectedtd: any;
    public tddate: Date;
    public Code: any;
  TodayDate = new Date();
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  SelectedToDate: NgbDateStruct;

  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;
  CurrentLabOrderRequestsController: LabOrderRequestsController[];
  CurrentLabOrdersRequest: LabOrdersRequest;
  LoadOrders() {
    var getReq = new LabOrdersRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101046;
    getReq.FacilityCode = this.SelectedFacilityCode;
    if (this.isdisplaydate) {
      getReq.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      getReq.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));
    }
    else if (!this.isdisplaydate) {
      getReq.FromDate = new Date();
      getReq.ToDate = new Date();
    }
    getReq.Department = this.SelectedDepCode;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    //console.log('str-' + str);
    gReq.ConditionalOperator = 101046;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentLabOrderRequestsController = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();

          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
          //this.LoadStoragedata();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  _LoadOrders(Value: string) {
    var getReq = new LabOrdersRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101046;
    getReq.FacilityCode = this.SelectedFacilityCode;    
    getReq.SearchText = Value;    
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101046;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {

        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentLabOrderRequestsController = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();

          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
          //this.LoadStoragedata();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  LoadForms() {
    this.CurrentLabOrdersRequest = new LabOrdersRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentLabOrdersRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentExpenseVouchersController;
    // this.pdata = this.CurrentFollicularScansBetweenDateController;
    this.GetLabOrderRequestsController();
  }
  //public SelectedReport: string;
  _GetLabOrderRequestsController(Value: string) {
    this.StartRefreshing();
    //this.spinner.show();
    this.CurrentLabOrdersRequest.FacilityCode = this.SelectedFacilityCode;

    this.CurrentLabOrdersRequest.SearchText = Value;
    this.CurrentLabOrdersRequest.ConditionalOperator = 30;
    //alert(this.FormattedCode);
    this.actorservice.GetLabOrderRequestsController(this.CurrentLabOrdersRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentLabOrderRequestsController = this.ApiResData.Result;
          //this.pdata = this.CurrentExpenseVouchersController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          //this.spinner.hide();
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
    GetLabOrderRequestsController() {
       // alert(this.Selectedtoday);
    this.StartRefreshing();
    //this.spinner.show();
    this.CurrentLabOrdersRequest.FacilityCode = this.SelectedFacilityCode;
    if (this.isdisplaydate) {
      this.CurrentLabOrdersRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
      this.CurrentLabOrdersRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));
    }
    else if (!this.isdisplaydate) {
      this.CurrentLabOrdersRequest.FromDate = new Date();
      this.CurrentLabOrdersRequest.ToDate = new Date();
    }
    this.CurrentLabOrdersRequest.Department = this.SelectedDepCode;
    this.CurrentLabOrdersRequest.ConditionalOperator = 10;
    //alert(this.FormattedCode);
    this.actorservice.GetLabOrderRequestsController(this.CurrentLabOrdersRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentLabOrderRequestsController = this.ApiResData.Result;
          //this.pdata = this.CurrentExpenseVouchersController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          //this.spinner.hide();
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
    }
    
    public DateCheck: any;
    public Selectedone: Date;
  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    public printService: PrintService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService, private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService, private filter: ExpenseVoucherpipe, private spinner: NgxSpinnerService, ) { }

    ngOnInit() {
        
        this.LoadData = this.route.snapshot.paramMap.get('LoadData');
        if (this.LoadData == "yes") {
          
            this.Selectedfd = this.route.snapshot.paramMap.get('SelectedFromDate2')
            this.frdate = new Date(this.Selectedfd);
            if (this.frdate != null) {
                var SValidFrom = new Date(this.frdate);
                if (SValidFrom.getFullYear() > 1900) {
                    console.log('this.UpdateDate >1990');
                    this.SelectedFromDate = {

                        year: SValidFrom.getFullYear(),
                        month: SValidFrom.getMonth() + 1,
                        day: SValidFrom.getDate()
                    }
                }
            }
            this.Selectedtd = this.route.snapshot.paramMap.get('SelectedToDate');   
            this.tddate = new Date(this.Selectedtd);
            if (this.tddate != null) {
                var SValidFrom = new Date(this.tddate);
                if (SValidFrom.getFullYear() > 1900) {
                    console.log('this.UpdateDate >1990');
                    this.SelectedToDate = {

                        year: SValidFrom.getFullYear(),
                        month: SValidFrom.getMonth() + 1,
                        day: SValidFrom.getDate()
                    }
                }
            }
            this.Code = this.route.snapshot.paramMap.get('SelectedFacilityCode');
            this.SelectedFacilityCode = this.Code;
            this.SelectedDepCode = Number(this.route.snapshot.paramMap.get('SelectedDepCode'));  
           this.SelectedDuration = this.route.snapshot.paramMap.get('SelectedDuration');
            this.Selectedtoday = this.route.snapshot.paramMap.get('Selectedtoday');
            this.isdisplaydate = Boolean(this.route.snapshot.paramMap.get('isdisplaydate'));
          //this.LoadForms();
          this.LoadOrders();
        }
        else if (this.LoadDataOld == "Yes") {
           
            this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
            this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
            this.SelectedFacilityCode = AppData.Instance().SelectedBranchCode;
            this.SelectedFacilityName = AppData.Instance().SelectedBranchName;
        }

        this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
        this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();


    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
   
    this.isNew = true;
    //this.Lab = this.route.snapshot.paramMap.get('RefundCode');

    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.SelectedPatient.FormattedCode;
    //this.LoadForms();
    //this.GetPatientInfoByFormattedCodeController();

  }

    //GetLabOrderRequestsController2() {
    //    this.StartRefreshing();
    //    if (this.isdisplaydate) {
    //        this.CurrentLabOrdersRequest.FromDate = this.frdate;
    //        this.CurrentLabOrdersRequest.ToDate = this.tddate;
    //    }
    //    else if (!this.isdisplaydate) {
    //        this.CurrentLabOrdersRequest.FromDate = new Date();
    //        this.CurrentLabOrdersRequest.ToDate = new Date();
    //    }
    //    this.CurrentLabOrdersRequest.FacilityCode = this.SelectedFacilityCode;
    //    this.CurrentLabOrdersRequest.Department = this.SelectedDepCode;
    //    this.CurrentLabOrdersRequest.ConditionalOperator = 10;
       
    //    this.actorservice.GetLabOrderRequestsController(this.CurrentLabOrdersRequest)
    //        .subscribe((result) => {
    //            this.ApiResData = result;
    //            if (!this.ApiResData.hasError) {
    //             this.CurrentLabOrderRequestsController = this.ApiResData.Result;
                   
    //                this.stopRefreshing();
                  
    //            }
    //            else {
    //                this.stopRefreshing();
    //                if (this.ApiResData.ErrorData != "") {

    //                    alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
    //                }
    //                else {
    //                    alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
    //                }
    //            }

    //        },


    //            (error) => {

    //                if (error == "401 - Unauthorized") {
    //                    alertFunctions.AlertParamEr(error);
    //                    this.stopRefreshing();



    //                }
    //                else {
    //                    alertFunctions.AlertParamEr(error);
    //                    this.stopRefreshing();
    //                }
    //            }


    //        );
    //}

  ShowList: boolean = true;

  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }
  DeleteLabOrder(l) {
    swal({
      title: 'Are you sure?',
      text: "You want to delete!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.DeleteLab(l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  DeleteLab(l) {
    var saveReq = new DeleteLabOrderRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 80140;
    saveReq.ActorCode = l.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.OrderCode = l.OrderCode;
    saveReq.OrderTestCode = l.OrderTestCode;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 80140;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.LoadOrders();
            //this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
    onSubmit(e) {
       
        if (e.target.checked) {
           
            this.isdisplaydate = true;
            this.SelectedDuration = 'nameB';
        }
        else if (!e.target.checked) {
            //this.isdisplaydate = false;
            this.SelectedDuration = '';
        }
      
  }
    onSubmit2(e) {
       
        if (e.target.checked) {
            this.isdisplaydate = false;
            this.Selectedtoday = 'nameA';
        }
        else if (!e.target.checked) {
            //this.isdisplaydate = false;
            this.Selectedtoday = '';
        }

  }
  Go() {
    this.spinner.show();
    //this.LoadForms();
    this.LoadOrders();
    //this._GetExpenseVouchersController();
  }
  //_GetExpenseVouchersController() {
  //    this.StartRefreshing();
  //    //this.spinner.show();
  //    this.CurrentExpenseVouchersRequest.FacilityCode = this.SelectedFacilityCode;
  //    this.CurrentExpenseVouchersRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
  //    this.CurrentExpenseVouchersRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedToDate));
  //    this.CurrentExpenseVouchersRequest.ConditionalOperator = 20;
  //    //alert(this.FormattedCode);
  //    this.actorservice.GetExpenseVouchersController(this.CurrentExpenseVouchersRequest)
  //        .subscribe((result) => {
  //            this.ApiResData = result;
  //            if (!this.ApiResData.hasError) {
  //                //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
  //                this.CurrentExpenseVouchersController = this.ApiResData.Result;
  //                this.pdata = this.CurrentExpenseVouchersController;
  //                this.spinner.hide();
  //                // this.pdata = this.CurrentFollicularScansBetweenDateController;
  //                //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

  //                //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
  //                //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
  //                //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
  //                //this.spinner.hide();
  //                this.stopRefreshing();
  //                //   this.LoadGuardian();
  //                //this.LoadMessages();
  //                //this.LoadOvaryData();

  //            }
  //            else {
  //                this.stopRefreshing();
  //                if (this.ApiResData.ErrorData != "") {

  //                    alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //                }
  //                else {
  //                    alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //                }
  //            }

  //        },


  //            (error) => {

  //                if (error == "401 - Unauthorized") {
  //                    alertFunctions.AlertParamEr(error);
  //                    this.stopRefreshing();



  //                }
  //                else {
  //                    alertFunctions.AlertParamEr(error);
  //                    this.stopRefreshing();
  //                }
  //            }


  //        );
  //}
  //pdata: any[];// = this.data;
  //listFilter: string;

  //criteriaChange(value: any) {
  //    if (this.filter != null) {
  //        if (value != '[object Event]') {
  //            this.listFilter = value;
  //            //alert(this.listFilter);
  //            this.pdata = this.filter.transform(this.CurrentExpenseVouchersController,
  //                this.listFilter);
  //        }
  //    }
  //}
 public SelectedFacilityCode: number;
  SelectedFacilityName: string;
  Branchdata(event: any) {

    if (event != null) {

      // alert(event);
      this.SelectedFacilityName = event;
    }

  }
  SelectedDepCode: number;
  DepData(event: any) {

    if (event != null) {

      // alert(event);
    }

  }
  //AddNewPatient() {

  //  const modalRef = this.modalService.open(NgbAddNewPatient,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;

  //  modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  //}
  CancelNewOperation() {

    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }

  SelectedPatient: PatientInfoByFormattedCodeController;
  ViewPatientDetails(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;

    if (patient != null) {



      this.ShowPatientDetails = true;
      this.ShowList = false;
      this.SelectedPatient = patient;
      this.Showarrow = true;
      this.Showrow = false;
      this.ShowRegister = false;
      //this.LoadPatientdetails()

    }
    else {
      this.ShowPatientDetails = false;
    }
  }
  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {


  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();

  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}


  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    //this._GetBillDetailsInfoController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    //this._GetBillDetailsInfoController();
    //ind++;
  }

  //capture(l: PatientInfoByFormattedCodeController) {
  //  const modalRef = this.modalService.open(NgbCameraUploadModal,
  //    {
  //      centered: true,


  //    })
  //  modalRef.componentInstance.ActorCode = l.ActorCode;
  //  modalRef.componentInstance.Photo = l.Photo;
  //}
  criteriaChange(value: string) {
    //this._GetLabOrderRequestsController(value);
    this._LoadOrders(value);

  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
    //this._GetLabOrderRequestsController(this.searchValue);
    this._LoadOrders(this.searchValue);
  }
  ViewOrder() {
    this.router.navigate(['/healins/vieworder']);
  }
  dataChanged(newobj) {

  }
  Payment() {

  }
  DisplaySelected() {
    this.DetailsSection = true;
  }
  Specimen2(l: LabOrderRequestsController) {
      this.router.navigate(['healins/SpecimenCollection2', {
          Laborder: l.OrderCode, BranchName: this.SelectedFacilityName, SelectedFacilityCode: this.SelectedFacilityCode, PatientFormttedCode: l.PatientFormattedCode, OrderTestStatus: l.OrderTestStatus, Selectedtoday: this.Selectedtoday, SelectedDuration: this.SelectedDuration, SelectedFromDate: new Date(this.parserFormatter.format(this.SelectedFromDate)), SelectedToDate: new Date(this.parserFormatter.format(this.SelectedToDate)), SelectedDepCode: this.SelectedDepCode, isdisplaydate: this.isdisplaydate

    }]);
  }
  Resultsentry(l: LabOrderRequestsController) {
    this.router.navigate(['healins/resultsen', {
      Laborder: l.OrderCode, LaborderTestCode: l.OrderTestCode, BranchName: this.SelectedFacilityName, SelectedFacilityCode: this.SelectedFacilityCode, PatientFormttedCode: l.PatientFormattedCode, Selectedtoday: this.Selectedtoday, SelectedDuration: this.SelectedDuration, SelectedFromDate: new Date(this.parserFormatter.format(this.SelectedFromDate)), SelectedToDate: new Date(this.parserFormatter.format(this.SelectedToDate)), SelectedDepCode: this.SelectedDepCode, isdisplaydate: this.isdisplaydate

    }]);
  }
  AddNewPatient() {

  }
  //ViewItem(l: ExpenseVouchersController) {
  //          const modalRef = this.modalService.open(NgbViewItemDetailsModal,
  //        {
  //            centered: true

  //        })
  //    modalRef.componentInstance.Voucherno = l.VoucherNo;
  //    modalRef.componentInstance.TotalAmount = l.TotalAmount;
  //    modalRef.componentInstance.ReDate = l.ReceiptDate;

  //}

  printexpenses() {
    this.printService.printDocument("expensesreport",
      {
        SelectedFromDate: this.SelectedFromDate, SelectedToDate: this.SelectedToDate, Day: this.SelectedFromDate.day, year: this.SelectedFromDate.year, month: this.SelectedFromDate.month
      }
    );
  }

}
